/**
 * Copyright (c)
 * @fileoverview 快对作业 app 调起工具
 * @version 1.0 | 2019 | baiyanli  继承老仓库
 * @version 1.1 | 2020-10-15 | duankai  1.安卓下载使用iframe下载;
 *                                      2.ios9以上没有配置`universalLink`走`nativeLinkIos`修复历史bug;
 *                                      3.options添加download选项，探测app是否可调起时可选择没有安装app不下载；
 * @version 1.2 | 2020-12-3 | duankai   1.添加默认配置appStore；
 *                                      2.yyblink只在微信端内使用，安卓下载走downloadLink，ios下载走appStore；
 *                                      3.修改downloadLink默认配置，指向安卓最新正式包；
 **/
import browser from '@w/utils/browser';

const os = browser.os();

const OS = {
  android: /android/i.test(os),
  ios: /iPad|iPhone/i.test(os),
  weixin: /MicroMessenger/i.test(navigator.userAgent),
  version: /os_(.*)/i.test(os) && parseInt(RegExp.$1)
};

const defaultOpt = {
  download: true,
  appStore: 'https://itunes.apple.com/cn/app/kuai-dui-zuo-ye/id1330927814?mt=8',
  downloadLink: 'https://www.kuaiduizuoye.com/codesearch/download/apk?channel=kdzy-common&name=com_kuaiduizuoye_scan',
  yybLink: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.kuaiduizuoye.scan',
  nativeLinkIos: 'kwzy://com.kuaiduizuoye.scan/main/invite/activity',
  nativeLinkAndroid: 'kwzy://com.kuaiduizuoye.scan/main/invite/activity',
  universalLink: `//static.kuaiduizuoye.com/product/FECommon/Html/download/download.html?page=${encodeURIComponent(
    'showhomepage'
  )}`
};

function Sdk(opt = {}) {
  this.opt = Object.assign(defaultOpt, opt);
}

// 操作函数
Sdk.prototype.active = function () {
  if (OS.weixin) {
    this.openInWeixin();
  } else if (OS.ios && OS.version >= 9 && !OS.qqbrowser) {
    // universalLink ios9及以上唤起app
    this.openInIos9p();
  } else if (OS.ios || OS.android) {
    this.openWithIframe();
  } else {
    this.download();
  }
};

// 微信内下载，统一走应用宝的下载链接
Sdk.prototype.openInWeixin = function () {
  if (OS.ios && OS.version >= 9 && this.opt.universalLink) {
    this.openInIos9p();
  } else if (this.opt.yybLink) {
    location.href = this.opt.yybLink;
  } else {
    this.download();
  }
};

// ios9以上版本universalLink下载
Sdk.prototype.openInIos9p = function () {
  const self = this;
  if (self.opt.universalLink) {
    // 如果有universalLink，则通过universalLink唤起
    location.href = self.opt.universalLink;
  }
};

// ios 7/8 android 的打开APP （iframe打开）
Sdk.prototype.openWithIframe = function () {
  const self = this;
  let nativeLink;
  if (OS.ios) {
    nativeLink = self.opt.nativeLinkIos;
  } else if (OS.android) {
    nativeLink = self.opt.nativeLinkAndroid;
  }
  if (!nativeLink) {
    self.download();
    return;
  }
  self.openWithIframeFun(nativeLink, function (success) {
    if (!success) {
      self.download();
    }
  });
};

Sdk.prototype.openWithIframeFun = function (openUrl, callback) {
  // 检查 app 是否打开
  function checkOpen(cb) {
    const _clickTime = +new Date();
    function check(elsTime) {
      if (elsTime > 2000 || document.hidden || document.webkitHidden) {
        cb(1);
      } else {
        cb(0);
      }
    }
    // 启动间隔 20ms 运行的定时器，并检测累计消耗时间是否超过 2000ms，超过则结束
    let _count = 0;
    const intHandle = setInterval(function () {
      _count++;
      const elsTime = +new Date() - _clickTime;
      if (_count >= 75 || elsTime > 2000) {
        clearInterval(intHandle);
        check(elsTime);
      }
    }, 20);
  }

  // 在 iframe 中打开 app
  const ifr = document.createElement('iframe');
  ifr.src = openUrl;
  ifr.style.display = 'none';
  if (callback) {
    checkOpen(function (opened) {
      callback && callback(opened);
    });
  }

  document.body.appendChild(ifr);
  setTimeout(function () {
    document.body.removeChild(ifr);
  }, 2000);
};

// 直接下载链接
Sdk.prototype.download = function () {
  if (!this.opt.download) {
    return;
  }
  const self = this;
  let link = null;
  if (OS.ios) {
    link = this.opt.appStore;
  } else {
    link = this.opt.downloadLink;
  }
  if (OS.android) {
    self.createDownloadBridge(link);
  } else {
    location.href = link; // 直接跳转会存在白屏问题
  }
};

// iframe 下载桥
Sdk.prototype.createDownloadBridge = function (apk) {
  let ifr = document.querySelector('#apkDownload');
  if (ifr) {
    ifr.src = apk;
  } else {
    ifr = document.createElement('iframe');
    ifr.setAttribute('id', 'apkDownload');
    ifr.style.width = 0;
    ifr.style.height = 0;
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    ifr.src = apk;
  }
};
export default Sdk;
